import { injectable } from "inversify";
import { Either } from "fp-ts/lib/Either";
import ErrorEntity from "../../entities/ErrorEntity";
import StablishmentRepository from "../../repositories/StablishmentRepository";
import SearchResultEntity from "../../entities/SearchResultEntity";
import StablishmentEntity from "../../entities/StablishmentEntity";

interface _Props {
    stablishmentRepository: StablishmentRepository;
}

@injectable()
export default class SearchStablishmentsUseCase {
    private stablishmentRepository: StablishmentRepository;

    constructor(props: _Props) {
        this.stablishmentRepository = props.stablishmentRepository;
    }

    public call = async (_: {
        query?: string,
        page: number,
        itemsPerPage: number
    }): Promise<Either<ErrorEntity, SearchResultEntity<StablishmentEntity>>> => {
        return this.stablishmentRepository.searchStablishments(_);
    }
}

export const SearchStablishmentsUseCaseName = "SearchStablishmentsUseCase";